import { useState } from 'react';
import React from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic client‑side validation
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d6b7ianmvg9ih2c7b1h0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({ email }).toString(),
        }
      );

      if (!response.ok) {
        // Try to extract a useful error message from the server
        const errorData = await response.json().catch(() => null);
        const serverMessage = errorData?.message || 'Error. Try again.';
        setMessage(serverMessage);
      } else {
        setMessage('Subscribed!');
        setEmail('');
      }
    } catch (err) {
      console.error('Subscription error:', err);
      setMessage('Error. Try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer id="contact" className="bg-[#E2D9CA] px-6 py-8">
      <div className="max-w-7xl mx-auto bg-[#574407] rounded-3xl px-12 py-16 relative overflow-hidden">
        <div className="absolute bottom-0 right-0 text-[#936A0B]/20 text-9xl font-bold pointer-events-none select-none">
          ABEXIA
        </div>

        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <img
              src="https://public.readdy.ai/ai/img_res/269a2b39-9248-4bf4-bc27-6f4e4990cd54.png"
              alt="ABEXIA Logo"
              className="h-72 w-auto object-contain brightness-0 invert"
            />
          </div>

          <div>
            <h3 className="text-base font-semibold text-white uppercase mb-5">
              SHOP
            </h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="#collections"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Women&apos;s Fashion
                </a>
              </li>
              <li>
                <a
                  href="#collections"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Evening Wear
                </a>
              </li>
              <li>
                <a
                  href="#collections"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Casual Chic
                </a>
              </li>
              <li>
                <a
                  href="#party-bags"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Party Bags
                </a>
              </li>
              <li>
                <a
                  href="#gifts"
                  className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Kids Gifts
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-white uppercase mb-5">
              CONNECT
            </h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg text-[#EB9830]"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://pinterest.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-pinterest-line text-lg text-[#EB9830]"></i>
                  Pinterest
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-line text-lg text-[#EB9830]"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-tiktok-line text-lg text-[#EB9830]"></i>
                  TikTok
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-white uppercase mb-4">
              STAY UPDATED
            </h3>
            <form
              onSubmit={handleSubmit}
              className="space-y-3"
              data-readdy-form
              id="abexia-footer-newsletter"
            >
              <div className="flex items-center gap-0">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 h-11 px-4 rounded-l-full bg-[#936A0B]/30 border border-white/20 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-[#EB9830] text-sm"
                  disabled={isSubmitting}
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-11 h-11 rounded-full bg-[#EB9830] text-white flex items-center justify-center hover:bg-[#EB9830]/90 transition-colors duration-300 disabled:opacity-50 cursor-pointer whitespace-nowrap"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              {message && <p className="text-xs text-white/80">{message}</p>}
            </form>
          </div>
        </div>

        <div className="relative z-10 mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/60">
            &copy; 2024 ABEXIA. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-white/40 hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap"
            >
              Web Design
            </a>
            <span className="text-white/20">|</span>
            <span className="text-xs text-[#EB9830]">
              Designed By Mars Digitech
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
